import { useForm } from "react-hook-form"
import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import React, { useState, useEffect, useLayoutEffect } from "react"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "../TopSection"
import useAboutYou from "../hooks/useAboutYou"
import { useHistory } from "react-router"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"

const AboutYourPartnerName = ({ next, previous }) => {
  const history = useHistory()
  const { wentBack, goBack } = useAboutYouFlowControls()
  const { data, updateAboutYou, continueLoading } = useAboutYou()

  const [partnerFirstName, setPartnerFirstName] = useState(data?.partnerFirstName || "")
  const [partnerLastName, setPartnerLastName] = useState(data?.partnerLastName || "")

  useLayoutEffect(() => {
    if (!wentBack && data?.partnerFirstName) {
      history.push(next)
    }
  }, [data?.partnerFirstName, history, next, wentBack])

  useEffect(() => {
    setPartnerFirstName(data?.partnerFirstName)
    setPartnerLastName(data?.partnerLastName)
  }, [data?.partnerFirstName, data?.partnerLastName])

  const submitPartnerName = async (data) => {
    await updateAboutYou(data)
    history.push(next)
  }

  const isValidPartnerName = () => Boolean(partnerFirstName) && Boolean(partnerLastName)

  const { register, handleSubmit, errors } = useForm()
  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <ContinueArrow onClick={handleSubmit(submitPartnerName)} enabled={isValidPartnerName() && !continueLoading} />
        </FleContinueWrapper>
      }
    >
      <Form onSubmit={isValidPartnerName() && handleSubmit(submitPartnerName)}>
        <AboutYouTopSection previous={previous}>
          <TopSection progressStep={3} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
        </AboutYouTopSection>
        <SwitchH2ToBodyLarge>{`What's your partner's name?`}</SwitchH2ToBodyLarge>
        <Spacer height={2} />
        <CompleteFormInput
          name={"partnerFirstName"}
          label={"Partner's first name"}
          value={partnerFirstName}
          errors={errors}
          ref={register}
          onChange={(e) => {
            setPartnerFirstName(e.target.value)
          }}
        />
        <CompleteFormInput
          name={"partnerLastName"}
          label={"Partner's last name"}
          value={partnerLastName}
          errors={errors}
          ref={register}
          onChange={(e) => {
            setPartnerLastName(e.target.value)
          }}
        />
      </Form>
    </FleLayout>
  )
}

export { AboutYourPartnerName }
